import { render, staticRenderFns } from "./msgs.vue?vue&type=template&id=2676df73"
import script from "./msgs.vue?vue&type=script&lang=js"
export * from "./msgs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports